import { AlertTriangle } from "lucide-react";

import { Badge } from "../../../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";

const MeetingAlert = ({ isOpen, onOpenChange, upcomingMeetings }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-yale-blue-600 dark:text-primary">
            <AlertTriangle className="w-5 h-5" />
            Upcoming Meeting Alert!
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-slate-600 dark:text-slate-400">
            You have {upcomingMeetings.length} upcoming meeting
            {upcomingMeetings.length > 1 ? "s" : ""}:
          </p>
          {upcomingMeetings.map((lead) => (
            <div
              key={lead.id}
              className="p-4 bg-yale-blue-50 dark:bg-amber-900/10 rounded-xl border border-amber-100 dark:border-amber-900/30"
            >
              <div className="flex justify-between items-start mb-2">
                <h4 className="font-bold text-yale-blue-900 dark:text-slate-100">{lead.title}</h4>
                <Badge className="bg-amber-100 text-yale-blue-700 dark:bg-amber-900/30 dark:text-yale-blue-400 font-bold uppercase tracking-wider text-[10px]">
                  {lead.priority}
                </Badge>
              </div>
              <div className="space-y-1 text-sm text-slate-600 dark:text-slate-400">
                {lead.companyName && (
                  <p>
                    <strong className="text-yale-blue-900 dark:text-slate-200">Company:</strong> {lead.companyName}
                  </p>
                )}
                {lead.contactPerson && (
                  <p>
                    <strong className="text-yale-blue-900 dark:text-slate-200">Contact:</strong> {lead.contactPerson}
                  </p>
                )}
                <p className="text-yale-blue-600 dark:text-primary font-bold mt-2">
                  <strong className="text-yale-blue-900 dark:text-slate-200">Time:</strong>{" "}
                  {new Date(lead.meetingDate).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MeetingAlert;
